import PropTypes from 'prop-types'
import { useState } from 'react'
import { ListGroup, ListGroupItem, CustomInput, Collapse } from 'reactstrap'

const propTypes = {
  formik    : PropTypes.object,
  fieldName : PropTypes.string,
  sizes     : PropTypes.array
}

/**
 * @param {string} name - name of the field in formik
 * @param {[string]} sizes - options for sizes
 */
const defaultProps = {
  formik    : {},
  fieldName : '',
  sizes     : [ ]
}

const ProductSizeFilterField = ({
  formik,
  fieldName,
  sizes
}) => {
  const [ collapse, setCollapse ] = useState(true)

  let isSizesEmpty = false

  if (sizes.length == 0) {
    isSizesEmpty = true
  }

  const handleChange = (event, size) => {
    const { checked } = event.target
    const sizeId      = size.id
    if (checked) {
      // manually push to formik values
      const newSelectedSizeIds = [ ...formik.values[ fieldName ], sizeId ]
      formik.setFieldValue(fieldName, newSelectedSizeIds)
    } else {
      const newSelectedSizeIds = formik.values[fieldName].filter((formikSizeId) => formikSizeId !== sizeId)
      formik.setFieldValue(fieldName, newSelectedSizeIds)
    }
  }
  return (
    <>
      <div className='filter-title font-weight-bold pb-2'
        onClick={ () => setCollapse(!collapse) }
      >
        { 'SIZE' }

        {
          isSizesEmpty ?
            <p> { 'Category yang anda pilih tidak memiliki size' }</p>
            :
            <p> { 'size hanya akan muncul apabila Category yang dipilih memiliki size' }</p>
        }

        <i className={ `float-right fas fa-chevron-${ collapse ? 'up' : 'down' }` } />
      </div>

      <Collapse isOpen={ collapse }>
        <ListGroup flush>
          {
            sizes.map((size) => (
              <ListGroupItem
                key={ `sizes-filter-options-${size.id}` }
                name={ fieldName }
              >
                <CustomInput
                  id={ size.label }
                  name={ size.label }
                  type='checkbox'
                  checked={ formik.values[fieldName].includes(size.id) }
                  onChange={ (event) => handleChange(event, size) }
                  className='float-left'
                  label={ size.label }
                />
              </ListGroupItem>
            ))
          }
        </ListGroup>
      </Collapse>
    </>
  )
}

ProductSizeFilterField.propTypes    = propTypes
ProductSizeFilterField.defaultProps = defaultProps


export default ProductSizeFilterField
